import {Button} from "@app/components/Dashboard/dashboard/ui/button"
import {PaymentHistoryData} from "@shortsworks/user-api"
import {useReactTable, getCoreRowModel, flexRender, ColumnDef} from "@tanstack/react-table"

const columns: ColumnDef<PaymentHistoryData>[] = [
  {
    accessorKey: 'amount',
    header: '결제 금액',
    cell: ({ getValue }) => `${(getValue() as string).toLocaleString()}원`
  },
  {
    accessorKey: 'approvedAt',
    header: '결제 일자',
    cell: ({ getValue }) => new Date(getValue() as string).toLocaleDateString()
  },
  {
    accessorKey: 'cardCompany',
    header: '카드사',
    cell: () => <div>tosspay</div>
  },
  {
    accessorKey: 'receipt',
    header: '영수증',
    cell: ({ getValue }) => (
        <Button className="min-w-24" variant="outline">영수증</Button>
    )
  },
];

interface PaymentHistoryTableProps {
  data: PaymentHistoryData[];
}

// 테이블 형태 유사한 점 하나로 통일하기
export const PaymentHistoryTable = ({data}: PaymentHistoryTableProps) => {
  const table = useReactTable({
    data,
    columns,
    getCoreRowModel: getCoreRowModel(),
  });

  return (
      <table style={{ width: '100%', borderCollapse: 'collapse' }}>
        <thead>
        {table.getHeaderGroups().map(headerGroup => (
            <tr key={headerGroup.id}>
              {headerGroup.headers.map(header => (
                  <th className="text-left" key={header.id}>
                    {header.isPlaceholder
                        ? null
                        : flexRender(
                            header.column.columnDef.header,
                            header.getContext()
                        )}
                  </th>
              ))}
            </tr>
        ))}
        </thead>
        <tbody className="mt-4">
        {table.getRowModel().rows.map(row => (
            <tr key={row.id}>
              {row.getVisibleCells().map(cell => (
                  <td key={cell.id}>
                    {flexRender(cell.column.columnDef.cell, cell.getContext())}
                  </td>
              ))}
            </tr>
        ))}
        </tbody>
      </table>
  );
}